import React from 'react';
import { Container } from 'react-bootstrap';
var defaultProps = {
  url: '',
  fileName: '',
  mediaHeading: '',
  roundal: null,
  roundalBackgroundColour: 'red',
  roundalPosition: 'top-right'
};
var MediaFullPageBlock = function MediaFullPageBlock(_ref) {
  var url = _ref.url,
    fileName = _ref.fileName,
    mediaHeading = _ref.mediaHeading,
    roundal = _ref.roundal,
    roundalBackgroundColour = _ref.roundalBackgroundColour,
    roundalPosition = _ref.roundalPosition;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "media-block",
    className: "media-block"
  }, /*#__PURE__*/React.createElement(Container, {
    className: "py-5 text-center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-4 text-left"
  }, mediaHeading), /*#__PURE__*/React.createElement("div", {
    className: "position-relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: url,
    alt: fileName
  }), roundal && /*#__PURE__*/React.createElement("div", {
    className: "roundal " + roundalBackgroundColour + " " + roundalPosition
  }, roundal))));
};
MediaFullPageBlock.defaultProps = defaultProps;
export { MediaFullPageBlock };